import React, { useContext } from "react";
import ObjectSelectedHead from "./SelectedHead/ObjectSelectedHead";
import { popupcontext } from "../../../context/Popupscontext";
import ObjectMinimized from "../Object/ObjectMinimized/ObjectMinimized";
import ObjectSelectedTabs from "./SelectedBody/ObjectSelectedTabs";
import { useGetSpecificVehicleImeiQuery } from "../../../Redux/service/Vehicles/Vehicles";
import ObjectSelectedMap from "./SelectedMap/ObjectSelectedMap";
import { useSelector } from "react-redux";
import SelectedDeviceInf from "./SelectedBody/SelectedDevices/SelectedDeviceInf";
import SelectedDeviceAssign from "./SelectedBody/SelectedDevices/SelectedDeviceAssign";

export default function ObjectSelected({
	imei,
	device,
	position,
	setimei,
	type,
}) {
	let { objectselect, handleShowSelected } = useContext(popupcontext);
	let { data: Vehicles } = useGetSpecificVehicleImeiQuery(imei);
	const lang = localStorage.getItem("lang") || "en";
	const inf = useSelector((state) => state.users.user);
	return (
		<>
			{objectselect === true && (
				<div
					className={`bg-white-rounded p-0 object-selected ${
						lang === "en" ? "object-selected-ltr" : "object-selected-rtl"
					}`}
				>
					<div className="streetview">
						<ObjectSelectedHead
							values={Vehicles}
							device={device}
							setimei={setimei}
						/>
					</div>
					<ObjectSelectedMap
						values={Vehicles}
						device={device}
						position={position}
					/>

					{type === "vehicle" && (
						<>
							<ObjectSelectedTabs
								title="Vehicle Details"
								img="Cardetails"
								values={Vehicles}
								device={device}
								show={false}
							/>
							<ObjectSelectedTabs
								title="working status"
								img="CarBattery"
								values={Vehicles}
								device={device}
								position={position}
							/>
							<ObjectSelectedTabs
								title="sensors"
								img="Sensors"
								position={position}
								CarSensors={Vehicles}
							/>

							<ObjectSelectedTabs
								title="controls"
								img="Control"
								device={device}
							/>
						</>
					)}
					{type === "mobility" && (
						<>
							<SelectedDeviceInf
								values={Vehicles}
								device={device}
								show={false}
							/>
							<SelectedDeviceAssign
								values={Vehicles}
								device={device}
								show={false}
							/>
						</>
					)}
				</div>
			)}

			{objectselect === false && (
				<ObjectMinimized
					title="objectSelected"
					name={Vehicles?.name}
					minimize={handleShowSelected}
				/>
			)}
		</>
	);
}
